import React from 'react'
import PoPover from '../Popover'

export default function QuestionHelper({ text, icon }: { text: string; icon?: string }) {
  return <PoPover content={text} icon={icon} />
}
